module.exports = __webpack_public_path__ + "img/about-gear-library.5afa1e57.jpg";